import { makeStyles } from '@material-ui/core'

export const useStyles = makeStyles((theme) => ({
  root: {
    display: 'flex',
    flexDirection: 'column',
    border: `1px solid ${theme.palette.grey[300]}`,

    borderRadius: 8,
    margin: '8px 0'
  },
  top: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    padding: theme.spacing(2),
    [theme.breakpoints.down('sm')]: {
      flexDirection: 'column',
      gap: 16
    }
  },
  bottom: {
    display: 'flex',
    flexDirection: 'column',
    padding: theme.spacing(2)
  },
  btnContainer: {
    display: 'flex'
  },

  header: {
    fontWeight: 600,
    color: theme.palette.text.primary
  },
  btnText: {
    fontWeight: 600,
    color: theme.palette.primary.contrastText,
    marginRight: 8
  },
  redText: { color: theme.palette.primary.main, fontWeight: 500 },
  btn: { marginRight: 16 },
  row: {
    display: 'grid',
    alignItems: 'center',
    gridTemplateColumns: '1.4fr 1.4fr 0.9fr 0.8fr',
    [theme.breakpoints.down('sm')]: {
      gridTemplateColumns: ' 1fr',
      marginTop: 8
    },
    gap: theme.spacing(2),
    marginBottom: 8
  },
  room: {
    marginTop: -16
  },
  cell: {
    display: 'flex',
    justifyContent: 'space-between',
    padding: '0 16px',
    alignItems: 'center',
    height: '55%',
    marginTop: 10,
    borderRadius: 4,
    border: `1px solid ${theme.palette.grey[300]}`,
    [theme.breakpoints.down('sm')]: {
      height: '100%',
      marginTop: 0
    }
  },
  cellText2: { margin: '10px 0', fontSize: 15, fontWeight: 600 },
  chip: { fontSize: 13 },
  cellText: { marginLeft: '6px', fontSize: 15, fontWeight: 600 },
  radioIcon: {
    '& svg': {
      fontSize: 18
    }
  },
  divider: { margin: '8px 0' },
  circularProgress: {
    color: theme.palette.primary.main,
    margin: '0 8px',
    [theme.breakpoints.down('sm')]: {
      margin: 0
    }
  },
  checkText: { fontWeight: 600, marginBottom: 4 },
  TimePeriodFormContainer: { border: 'none', padding: 0 },
  circularText: {
    fontWeight: 500,
    color: theme.palette.text.primary,
    margin: '-3px 0'
  },
  circularContainer: { display: 'flex', alignItems: 'center' }
}))
